import { CoreInterfaces, DTOs } from "src/core/Models";
import * as Constants from "./../../../core/Constants";
import { findQuestionInService } from "src/utils/shared";

export const ExtraServicesProcessor: CoreInterfaces.QuestionProcessors = (
  appState: CoreInterfaces.AppState,
  serviceDTO: DTOs.ServiceDTO
) => {
  return {
    [Constants.ExtraServicesQuestions.Q1102]: (
      questionDTO: DTOs.QuestionDTO
    ): void => {
      const q1101 = findQuestionInService(
        serviceDTO,
        Constants.ExtraServicesQuestions.Q1101
      );
      questionDTO.state.isShown =
        q1101.state.isShown && q1101.data.userValue === Constants.YesNo.Yes;
    },
  };
};
